// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_CLIENT, CLIENT, DELETE_CLIENT, EDIT_CLIENT, GET_CLIENT } from '../../../../common/constant'

export const actionClient = createAsyncThunk('appClient/actionClient', async (params, thunkAPI) => {
    return await post(CLIENT, params, thunkAPI)
})

export const actionAddClient = createAsyncThunk('appClient/actionAddClient', async (params, thunkAPI) => {
    return await put(ADD_CLIENT, params, thunkAPI)
})

export const actionGetClient = createAsyncThunk('appClient/actionGetClient', async (params, thunkAPI) => {
    return await post(GET_CLIENT, params, thunkAPI)
})

export const actionEditClient = createAsyncThunk('appClient/actionEditClient', async (params, thunkAPI) => {
    return await post(EDIT_CLIENT, params, thunkAPI)
})

export const actionDeleteClient = createAsyncThunk('appClient/actionDeleteClient', async (params, thunkAPI) => {
    return await post(DELETE_CLIENT, params, thunkAPI)
})

export const appClientSlice = createSlice({
    name: 'appClient',
    initialState: {
        //list
        loading: false,
        client: null,

        //add
        loadingAdd: false,
        addClient: null,

        //get
        loadingGet: false,
        getClient: null,

        //edit
        loadingEdit: false,
        editClient: null,

        //delete
        loadingDelete: false,
        deleteClient: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetClientResponse: (state) => {
            state.client = null
        },
        resetAddClientResponse: (state) => {
            state.addClient = null
        },
        resetGetClientResponse: (state) => {
            state.getClient = null
        },
        resetEditClientResponse: (state) => {
            state.editClient = null
        },
        resetDeleteClientResponse: (state) => {
            state.deleteClient = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionClient.pending, (state) => {
                state.loading = true
            })
            .addCase(actionClient.fulfilled, (state, action) => {
                state.loading = false
                state.client = action.payload
            })
            .addCase(actionClient.rejected, (state) => {
                state.loading = false
            })

            //add
            .addCase(actionAddClient.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddClient.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addClient = action.payload
            })
            .addCase(actionAddClient.rejected, (state) => {
                state.loadingAdd = false
            })

            //get
            .addCase(actionGetClient.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetClient.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getClient = action.payload
            })
            .addCase(actionGetClient.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditClient.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditClient.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editClient = action.payload
            })
            .addCase(actionEditClient.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteClient.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteClient.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteClient = action.payload
            })
            .addCase(actionDeleteClient.rejected, (state) => {
                state.loadingDelete = false
            })
    }
})
export const { resetClientResponse, resetAddClientResponse, resetGetClientResponse, resetEditClientResponse, resetDeleteClientResponse } = appClientSlice.actions

export default appClientSlice.reducer